var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.97,
    height: 66.969,
    viewBox: "0 0 66.97 66.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M57.173,9.8a33.483,33.483,0,1,0,0,47.378A33.539,33.539,0,0,0,57.173,9.8ZM47.3,43.361a2.791,2.791,0,1,1-3.948,3.947l-9.869-9.872L23.62,47.306a2.791,2.791,0,0,1-3.948-3.947l9.866-9.869-9.869-9.869a2.791,2.791,0,0,1,3.947-3.947l9.869,9.869,9.869-9.869A2.791,2.791,0,0,1,47.3,23.621l-9.869,9.869Z",
    transform: "translate(0 -0.005)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d71d00d1f7c48c789ec92b679bba3147.svg";
export { ForwardRef as ReactComponent };